export default __webpack_public_path__ + "static/media/greeting10.45c73583.png";